import * as React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'

import Layout from '../../layouts/main-layout'
import SystemMessageWrapper from '../../ui/system-message-wrapper'
import UserAuthWindow from '../../containers/user-auth-window'
import MetaData from '../../components/MetaData'

const LoginRoute = () => {
  const history = useHistory()
  const location = useLocation()
  let url = '/'
  let errorCode = ''
  const query = queryString.parse(location.search)
  if (query && query.url) {
    url = query.url
  }
  if (query && query.errorCode) {
    errorCode = query.errorCode
  } else if (query && query.error) {
    errorCode = query.error
  }

  return (
    <Layout showSearch>
      <MetaData
        title="Logg inn hos Gigplanet"
        description="Gigplanet hjelper deg å finne live underholdning til ditt arrangement, samtidig som vi hjelper artister å få flere spillejobber"
      />
      <SystemMessageWrapper>
        <UserAuthWindow
          errorCode={errorCode}
          successUrl={url}
          onClose={() => {
            history.push('/')
          }}
        />
      </SystemMessageWrapper>
    </Layout>
  )
}

export default LoginRoute
